var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play_button_svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 60C0 26.8629 26.863 0 60.0001 0C75.913 0 91.1743 6.32142 102.427 17.5735C113.679 28.8258 120 44.0871 120 60C120 93.137 93.1372 120 60.0001 120C26.863 120 0 93.137 0 60ZM49.0203 85.6801L84.0002 63.84C85.3092 63.0017 86.101 61.5545 86.101 60C86.101 58.4457 85.3092 56.9982 84.0002 56.1601L48.9002 34.32C47.5178 33.4484 45.7713 33.3948 44.3381 34.1799C42.9048 34.9651 42.0098 36.4656 42.0003 38.1V81.9001C41.981 83.5741 42.8924 85.1205 44.3664 85.9141C45.8404 86.7079 47.6332 86.6177 49.0203 85.6801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayBtn);
export default __webpack_public_path__ + "static/media/video_play_btn.06afa53aa0e01007402a2d10d646072d.svg";
export { ForwardRef as ReactComponent };